/**
 * User-friendly messages for Supabase free-tier and quota errors.
 * Use when surfacing API/auth errors so users know how to fix (e.g. restore paused project).
 */

const SUPABASE_DASHBOARD = 'https://supabase.com/dashboard';

export function getSupabaseFreeTierMessage(error: unknown): string | null {
  if (!error || typeof error !== 'object') return null;
  const msg = (error as { message?: string }).message ?? '';
  const cause = (error as { cause?: { message?: string; status?: number } }).cause;
  const status = (error as { status?: number }).status ?? cause?.status;
  const code = (error as { code?: string }).code ?? '';
  const causeMsg = cause?.message ?? '';

  // No HTTP response (network failure, blocked, or server unreachable)
  if (
    status === 0 ||
    (status == null && /failed to fetch|AuthRetryableFetchError|network error/i.test(msg + causeMsg))
  ) {
    return 'Connection failed—no response from the server. Check your internet, try again in a moment, or switch between Wi‑Fi and mobile data.';
  }

  if (status === 540) {
    return `Supabase project is paused (free tier inactivity). Restore it: ${SUPABASE_DASHBOARD} → your project → Project Settings → General → Restore project.`;
  }
  if (status === 429 || /rate limit|too many requests/i.test(msg) || code === '429') {
    return 'Supabase rate limit reached. Wait a few minutes or adjust limits in Dashboard → Authentication → Rate Limits.';
  }
  if (status === 544) {
    return 'Request timed out (Supabase free tier). Try again in a moment.';
  }
  if (status === 546) {
    return 'Supabase resource limit exceeded. Check your plan or try again later.';
  }
  return null;
}
